package org.matthewo.math

import kotlin.math.abs

fun Int.toOrdinal(): String {
    if (this < 0) return "-${abs(this).toOrdinal()}"
    val lastDigit = this % 10
    val lastTwoDigits = this % 100

    return when {
        lastTwoDigits in 11..13 -> "${this}th"
        lastDigit == 1 -> "${this}st"
        lastDigit == 2 -> "${this}nd"
        lastDigit == 3 -> "${this}rd"
        else -> "${this}th"
    }
}
